import { Outlet } from 'react-router-dom';

export const SIOsOutlet = () => <Outlet />;
